import { Injectable } from '@angular/core';
import {BehaviorSubject, Subject} from "rxjs";
import {PaymentStatusDto} from "../models/payment.models";

@Injectable({
  providedIn: 'root'
})
export class PaymentStatusService {

  paymentStatusService$: Subject<PaymentStatusDto | null> = new BehaviorSubject<PaymentStatusDto | null>(null)

}
